/* eslint-disable import/first */
import React from 'react';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector } = Redux;
import { useNavigate, useLocation } from '@reach/router';
import { Button, Grid, Typography } from '@material-ui/core';
const { selectFirstMenu } = Slices.menuSlice;
import { FormattedMessage, useIntl } from 'react-intl';
const { selectCurrentCurrency } = Slices.configSlice;
import appliedIcon from '../Offers/offerApplied.svg';

import css from './index.module.scss';

import { decimalChecker } from 'spwa-ui-library/esm/utils/helper';
import PopUpHeading from '../../components/PopUpHeading';

function OfferApplied({ discountAmount, handleClose, freeItem, cartData }) {
  const navigate = useNavigate();
  const location = useLocation();
  const intl = useIntl();
  const currency = useSelector(selectCurrentCurrency);
  const { discount, isFreeItem, isDiscountedItem } = location.state || {};
  const closePopup = () => {
    navigate(-1);
  };
  // const country = useSelector(selectCurrentCountry);
  // eslint:fix country is defined but is never used

  const renderOfferMessage = () => {
    if (isFreeItem || cartData?.couponType === 'freeitem') {
      return (
        <Typography>
          <FormattedMessage
            id="offer_applied_free_item"
            defaultMessage="Offer Applied! You just added a free item to your cart."
          />
        </Typography>
      );
    } else if (isDiscountedItem || cartData?.couponType === 'discountItem') {
      return (
        <Typography>
          <FormattedMessage
            id="offer_applied_discounted_item"
            defaultMessage="Offer applied! You just got a discounted item added to your cart."
          />
        </Typography>
      );
    } else {
      return (
        <Typography>
          <FormattedMessage
            id="offer_applied1"
            defaultMessage="Offer Applied! You just received a discount of "
          />
          {(discountAmount && decimalChecker(discountAmount)) ||
            (discount && decimalChecker(discount))}{' '}
          {intl.formatMessage({ id: 'offer_applied3' }, { currency: currency })}
        </Typography>
      );
    }
  };

  return (
    <div className={css.root}>
      <PopUpHeading heading="Coupon Applied" onClose={closePopup} />
      <Grid className={css.confettiBody}>
        <Grid className={css.circle}>
          <img src={appliedIcon} alt="offer applied" />
        </Grid>
        <Grid className={css.warningHeadText}>
          <Typography>
            <FormattedMessage id="woohoo" defaultMessage="Woohoo!" />
          </Typography>
        </Grid>
        <Grid className={css.rewardApplyDesc}>{renderOfferMessage()}</Grid>
        <Grid className={css.buttonContainer}>
          <Button className={css.button} onClick={handleClose || closePopup}>
            {isFreeItem || freeItem ? (
              <FormattedMessage id="offer_gotit" defaultMessage="continue" />
            ) : (
              <FormattedMessage id="gotit" defaultMessage="Got it" />
            )}
          </Button>
        </Grid>
      </Grid>
    </div>
  );
}

export default OfferApplied;
